import { InsightCatalogue } from '../InsightCatalogue';
import {
  DataOnlyInsightPayload,
  BaseInsightPayload,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsBusinessUnitDemandPayload
  extends DataOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT_DEMAND;
    id: string;
    attributes: {
      data: Array<{
        business_unit_id: string | null;
        business_unit_title: string;
        projects_without_tasks: number;
        partially_scoped_projects: number;
        fully_scoped_projects: number;
        total_project_count: number;
        total_demand_hours: number;
      }>;
    };
  };
}

export const parseProjectsBusinessUnitDemandPayload = (
  payload: BaseInsightPayload
): ProjectsBusinessUnitDemandPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT_DEMAND,
    data.attributes,
    true,
    false
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      business_unit_id: string | null;
      business_unit_title: string;
      projects_without_tasks: number;
      partially_scoped_projects: number;
      fully_scoped_projects: number;
      total_project_count: number;
      total_demand_hours: number;
    }>;
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_BUSINESS_UNIT_DEMAND,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
